

export function commonlibs_getfirstplot_mode(type_view) {
    var arr_out1 = ["Daily", "Monthly", "Yearly"];
    var arr_out2 = ["daily-h", "monthly", "yearly"];
    const dt = new Date();
    let hr = dt.getHours()
    let dayx = dt.getDate()
    let month = dt.getMonth()
    if (hr < 3) {
        hr = 3
    }
    if (hr >= 10) {
        if (type_view > 0) {
            return "daily-h"
        }
        return "Daily"
    }
    if (dayx >= 5) {
        if (type_view > 0) {
            return "nonthly"
        }
        return "Monthly"
    }

    const hr_p = ((hr - 3) / 16) * 100
    const day_p = (dayx / 31) * 100
    const month_p = ((month + 1) / 12) * 100
    var a = [hr_p, day_p, month_p];

    if (type_view > 0) {
        var indexOfMaxValue2 = a.reduce((iMax, x, i, arr) => x > arr[iMax] ? i : iMax, 0);
        return arr_out2[indexOfMaxValue2]
    }
    var indexOfMaxValue1 = a.reduce((iMax, x, i, arr) => x > arr[iMax] ? i : iMax, 0);
    return arr_out1[indexOfMaxValue1]
};